<div role="status" aria-live="polite" aria-atomic="true">
  @if (rejectedChanges > 0) {
    <div class="rejection-warning">
      <i class="material-icons" aria-hidden="true">warning</i>
      <span>{{ 'app.offlineToolbar.rejectedChanges' | translate: { count: rejectedChanges } }}</span>
    </div>
  }
</div>
@if (rejectedChanges > 0 || reviewing) {
  <div class="rejection-controls">
    <button mat-button (click)="toggleReview()" [attr.aria-expanded]="reviewing" aria-controls="rejected-change-list">
      <mat-icon aria-hidden="true">{{ reviewing ? 'expand_less' : 'visibility' }}</mat-icon>
      {{ (reviewing ? 'app.offlineToolbar.closeReview' : 'app.offlineToolbar.review') | translate }}
    </button>
  </div>
}
<div role="status" aria-live="polite" aria-atomic="true">
  @if (resolutionMessage) {
    {{ resolutionMessage | translate }}
  }
</div>
@if (reviewing) {
  <section
    id="rejected-change-list"
    class="rejected-change-list"
    [attr.aria-label]="'app.offlineToolbar.review' | translate"
  >
    @if (!online || !loaderService.isBackendReachable) {
      <p>{{ 'app.offlineToolbar.connectionRequired' | translate }}</p>
    }
    @for (change of rejectedItems; track change.id) {
      <article class="rejected-change">
        <h3>{{ change.type }}</h3>
        <dl>
          <dt>{{ 'app.offlineToolbar.changeId' | translate }}</dt>
          <dd>{{ change.key }}</dd>
          <dt>{{ 'app.offlineToolbar.created' | translate }}</dt>
          <dd>{{ change.created | date: 'medium' }}</dd>
          <dt>{{ 'app.offlineToolbar.reason' | translate }}</dt>
          <dd>
            {{
              (change.rejectionCode === 'CHANGE_REJECTED'
                ? 'app.offlineToolbar.handlerRejected'
                : 'app.offlineToolbar.invalidChange'
              ) | translate
            }}
          </dd>
          <dt>{{ 'app.offlineToolbar.attachments' | translate }}</dt>
          <dd>{{ change.attachments?.length || 0 }}</dd>
        </dl>
        <pre>{{ change.content | json }}</pre>
        @if (downloadedChangeKeys.has(change.key)) {
          <p>{{ 'app.offlineToolbar.downloadBlocksDiscard' | translate }}</p>
        }
        <button
          mat-stroked-button
          color="warn"
          (click)="discard(change)"
          [disabled]="
            discarding || !online || !loaderService.isBackendReachable || downloadedChangeKeys.has(change.key)
          "
        >
          <mat-icon aria-hidden="true">delete</mat-icon>
          {{ 'app.offlineToolbar.discard' | translate }}
        </button>
      </article>
    }
  </section>
}
@if (showOfflineControls) {
  <div class="offline-toolbar apd-dark-theme">
    <div class="title">{{ 'app.offlineToolbar.info' | translate }}</div>
    @if (online) {
      <div class="description">- {{ 'app.offlineToolbar.connected' | translate }}</div>
    }
    @if (!online) {
      <div class="description">- {{ 'app.offlineToolbar.disconnected' | translate }}</div>
    }
    <div class="status">
      <i class="material-icons">{{ online ? 'wifi' : 'wifi_off' }}</i>
    </div>
    <div class="description">{{ 'app.offlineToolbar.offlineChanges' | translate }}: {{ offlineChanges }}</div>
    <div class="description">
      <i class="material-icons" (click)="fetchPendingCount()">{{ 'autorenew' }}</i>
    </div>
    @if (online) {
      <div class="switchMode">
        <button mat-flat-button color="primary" (click)="switchToOnline()">
          {{ 'app.offlineToolbar.switchToOnline' | translate }}
        </button>
      </div>
    }
  </div>
}
